
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/check/oauth-sharing",
      function () {
        return require("private-next-pages/docs/check/oauth-sharing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/check/oauth-sharing"])
      });
    }
  